let videoZoomBtns = document.querySelectorAll('[data-video-zoom]');
let modalCloseBtns = document.querySelectorAll('[data-close-zoom-modal]');
let mainVideoModal = document.querySelector('[data-video-zoom-modal]');
let videoModalContainer = document.querySelector('[data-video-modal-inner]');

if(videoZoomBtns.length) {
  videoZoomBtns.forEach(async (btn) => {
    btn.addEventListener('click', function(el) {
        let mediaId = el.target.getAttribute('data-video-zoom');
        let videoEL = document.querySelector(`.video-${mediaId}`);
        let clonedVideo = videoEL.cloneNode(true); 
        videoModalContainer.appendChild(clonedVideo);
        mainVideoModal.classList.add('open');
        clonedVideo.play();
    });
  });
}

if(modalCloseBtns.length) {
  modalCloseBtns.forEach(async (btn) => {
    btn.addEventListener('click', function(el) {
          mainVideoModal.classList.remove('open');
          videoModalContainer.innerHTML = '';
    });
  });
}